import React from 'react'
import Img from './img.jpg'
import classNames from 'classnames'

import styles from './index.module.scss'

export default class Index extends React.PureComponent {
  state = {
    actived: ''
  }

  handleClick = (item) => {
    const { onClick } = this.props

    this.setState({
      actived: item.name
    })

    onClick(item.name, item)
  }

  componentDidMount () {}

  render () {
    const { dots = [], defaultActived, mobile } = this.props

    let _defaultActived = ''
    if (typeof defaultActived === 'number') {
      _defaultActived = (dots[defaultActived] || {}).name
    } else if (typeof defaultActived === 'object') {
      _defaultActived = defaultActived.name
    } else {
      _defaultActived = defaultActived
    }

    const imgStyle = mobile ? styles.mobileImg : styles.img

    return (


      <div className={styles.wrap}>
        <img src={Img} alt="" className={imgStyle} />
        {dots.map(item =>
          <div
            key={item.name}
            onClick={() => this.handleClick(item)}
            className={classNames(styles.dot, {
              [styles.active]: item.name === (this.state.actived || _defaultActived)
            })}
            style={{ left: item.left, top: item.top }}
          ></div>
        )}
      </div>
    )
  }
}
